define('widgets/simpleView/viewmodel',['plugins/widget', 'durandal/composition', 'jquery', 'knockout', 'services/trace'],
function (widget, composition, $, ko, trace) {
	var ctor = function () { };

	ctor.prototype.controller = function () {
		return this.settings.controller;
	};


	ctor.prototype.activate = function (settings) {
		this.settings = settings;

		if (this.controller().result().length == 0) {
			return Q.when(this.controller().load());
		}

		return true;
	};

	ctor.prototype.refresh = function () {
		return Q.when(this.controller().load());
	};

	return ctor;
});

